module.exports = function() {
  if(window.ota_singlepage_version) {
    return {
      version: window.ota_singlepage_version,
      platform: 'singlepage'
    }
  }
  else if(window.SINGLEPAGE_CONFIG && window.SINGLEPAGE_CONFIG.SINGLEPAGE_VERSION) {
    return {
      version: window.SINGLEPAGE_CONFIG.SINGLEPAGE_VERSION,
      platform: 'extranet'
    }
  }
  return {
    version: '',
    platform: ''
  }
};






//////////////////
// WEBPACK FOOTER
// ./lib/frontendversion.js
// module id = 14
// module chunks = 1 3